import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/Sidebar';
import EnglishDatePicker from '../../components/EnglishDatePicker/EnglishDatePicker';
import EditPourModal from '../../components/EditPourModal';
import '../Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://metro4.dcairo.com/api';

const CubesLog = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [pours, setPours] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [searchResults, setSearchResults] = useState(null);
  const [editPour, setEditPour] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [filters, setFilters] = useState({
    stations: [],
    specialSections: [],
    dateFrom: null,
    dateTo: null
  });
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const tableRef2 = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Drag to scroll handlers
  const handleMouseDown = (e, ref) => {
    setIsDragging(true);
    setStartX(e.pageX - ref.current.offsetLeft);
    setScrollLeft(ref.current.scrollLeft);
    ref.current.style.cursor = 'grabbing';
  };

  const handleMouseUp = (ref) => {
    setIsDragging(false);
    if (ref.current) ref.current.style.cursor = 'grab';
  };

  const handleMouseMove = (e, ref) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - ref.current.offsetLeft;
    const walk = (x - startX) * 2;
    ref.current.scrollLeft = scrollLeft - walk;
  };

  // Format date for API (YYYY-MM-DD)
  const formatDateForAPI = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // المحطات الثابتة (5) + الأقسام الخاصة (4)
  const stations = [
    { id: 'ST13', name: 'ST13 Giza', displayNumber: 'ST13', displayName: 'Giza', type: 'station', icon: '🗂️' },
    { id: 'ST14', name: 'ST14 Giza Square', displayNumber: 'ST14', displayName: 'Giza Square', type: 'station', icon: '🗂️' },
    { id: 'S15', name: 'S15 Alrawda', displayNumber: 'S15', displayName: 'Alrawda', type: 'station', icon: '🗂️' },
    { id: 'ST16', name: 'ST16 Almalek Elsaleh', displayNumber: 'ST16', displayName: 'Almalek Elsaleh', type: 'station', icon: '🗂️' },
    { id: 'ST17', name: 'ST17 Cut&Cover', displayNumber: 'ST17', displayName: 'Cut&Cover', type: 'station', icon: '🗂️' },
    { id: 'Chemical', name: 'Chemical Test', displayNumber: 'Chemical', displayName: 'Test', type: 'special', icon: '🧪' },
    { id: 'ES', name: 'E.S Cubes', displayNumber: 'E.S', displayName: 'Cubes', type: 'special', icon: '🔹' },
    { id: 'Grout', name: 'Grout', displayNumber: 'Grout', displayName: '', type: 'special', icon: '🔧' },
    { id: 'TM Trail', name: 'T.M Trail', displayNumber: 'T.M', displayName: 'Trail', type: 'special', icon: '🚇' }
  ];

  // جلب البيانات من Backend
  const fetchAllPours = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      let params = { status: 'approved' };
      
      const response = await axios.get(`${API_URL}/pours`, {
        headers: { Authorization: `Bearer ${token}` },
        params
      });

      if (response.data.success) {
        setPours(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching pours:', error);
      if (error.response?.status === 401) {
        toast.error('انتهت الجلسة، يرجى تسجيل الدخول مرة أخرى');
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllPours();
    fetchCurrentUser();
  }, []);

  const fetchCurrentUser = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCurrentUser(response.data.data.user);
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  };
  const formatDate = (date) => {
    if (!date) return '-';
    const d = new Date(date);
    const day = d.getDate(); // بدون صفر بادئ
    const month = d.getMonth() + 1; // بدون صفر بادئ
    const year = d.getFullYear();
    return (
      <div>
        <div>{`${day}/${month}`}</div>
        <div>{year}</div>
      </div>
    );
  };

  // تنسيق الوقت لنظام 24 ساعة
  const formatTime24 = (time) => {
    if (!time) return '-';
    
    // إذا الوقت بالفعل بصيغة HH:MM (24 ساعة)
    if (/^\d{2}:\d{2}$/.test(time)) {
      return time;
    }
    
    // إذا الوقت بصيغة 12 ساعة مع AM/PM
    const time12Format = /(\d{1,2}):(\d{2})\s*(AM|PM)/i;
    const match = time.match(time12Format);
    
    if (match) {
      let hours = parseInt(match[1]);
      const minutes = match[2];
      const period = match[3].toUpperCase();
      
      if (period === 'PM' && hours !== 12) {
        hours += 12;
      } else if (period === 'AM' && hours === 12) {
        hours = 0;
      }
      
      return `${String(hours).padStart(2, '0')}:${minutes}`;
    }
    
    // إرجاع القيمة كما هي إذا لم تطابق أي صيغة
    return time;
  };

  const handleEditPour = (pour) => {
    setEditPour(pour);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setEditPour(null);
    setShowEditModal(false);
  };

  const handleUpdateSuccess = () => {
    fetchAllPours();
  };

  // حساب تاريخ التكسير (DD-MM)
  const calculateBreakingDate = (castingDate, days) => {
    if (!castingDate) return '-';
    
    const date = new Date(castingDate);
    date.setDate(date.getDate() + days);
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    
    return `${day}-${month}`;
  };

  // تقسيم اسم المحطة لرقم واسم
  const formatStationName = (station) => {
    if (!station) return '-';
    // يفصل الرقم عن الاسم
    const parts = station.split(' ');
    if (parts.length > 1) {
      return (
        <div>
          <div>{parts[0]}</div>
          <div>{parts.slice(1).join(' ')}</div>
        </div>
      );
    }
    return station;
  };

  const calculateCubes = (cubes) => {
    if (!cubes) return 0;
    const { groups, cubesPerGroup } = cubes;
    if (groups && cubesPerGroup) {
      return parseInt(groups) * parseInt(cubesPerGroup);
    }
    return 0;
  };

  // حساب مكعبات Day 7 (⅓)
  const calculateDay7Cubes = (cubes) => {
    if (!cubes) return null;
    const { groups, cubesPerGroup } = cubes;
    if (!groups || !cubesPerGroup) return null;
    
    const totalCubes = parseInt(groups) * parseInt(cubesPerGroup);
    const day7Total = Math.round(totalCubes / 3); // ⅓
    const cubesPerGroupDay7 = Math.round(day7Total / parseInt(groups));
    
    return {
      groups: parseInt(groups),
      cubesPerGroup: cubesPerGroupDay7,
      total: parseInt(groups) * cubesPerGroupDay7
    };
  };

  // حساب مكعبات Day 28 (⅔)
  const calculateDay28Cubes = (cubes) => {
    if (!cubes) return null;
    const { groups, cubesPerGroup } = cubes;
    if (!groups || !cubesPerGroup) return null;
    
    const totalCubes = parseInt(groups) * parseInt(cubesPerGroup);
    const day7Total = Math.round(totalCubes / 3);
    const day28Total = totalCubes - day7Total; // ⅔
    const cubesPerGroupDay28 = Math.round(day28Total / parseInt(groups));
    
    return {
      groups: parseInt(groups),
      cubesPerGroup: cubesPerGroupDay28,
      total: parseInt(groups) * cubesPerGroupDay28
    };
  };

  // فلترة الصبات حسب المحطة أو القسم مع تطبيق فلاتر البحث
  const getPoursByStation = (stationId, stationType) => {
    return pours.filter(pour => {
      // فلترة حسب المحطة أو القسم
      let stationMatch = false;
      if (stationType === 'station') {
        stationMatch = pour.station === stations.find(s => s.id === stationId)?.name;
      } else if (stationType === 'special') {
        if (stationId === 'Chemical') stationMatch = pour.chemistry > 0;
        if (stationId === 'ES') stationMatch = pour.esCubes > 0;
        if (stationId === 'Grout') stationMatch = pour.testType === 'Grout';
        if (stationId === 'TM Trail') stationMatch = pour.testType === 'Trail';
      }

      return stationMatch;
    }).sort((a, b) => new Date(b.castingDate) - new Date(a.castingDate));
  };

  // الحصول على جميع الصبات المفلترة
  const getFilteredPours = () => {
    let filteredPours = [...pours];

    // فلترة حسب المحطات والأقسام الخاصة
    const hasStationFilter = filters.stations.length > 0;
    const hasSpecialFilter = filters.specialSections.length > 0;

    if (hasStationFilter || hasSpecialFilter) {
      filteredPours = filteredPours.filter(pour => {
        // إذا في محطات مختارة، تحقق لو الصبة من المحطات دي
        if (hasStationFilter) {
          const matchStation = filters.stations.some(stId => {
            const st = stations.find(s => s.id === stId);
            return pour.station === st?.name;
          });
          
          // لو الصبة من المحطة المختارة، خليها تظهر
          if (matchStation) return true;
        }

        // إذا في أقسام خاصة مختارة، تحقق لو الصبة منهم
        if (hasSpecialFilter) {
          const matchSpecial = filters.specialSections.some(sId => {
            if (sId === 'Chemical') return pour.chemistry > 0;
            if (sId === 'ES') return pour.esCubes > 0;
            if (sId === 'Grout') return pour.testType === 'Grout';
            if (sId === 'TM Trail') return pour.testType === 'Trail';
            return false;
          });
          
          // لو الصبة من الأقسام الخاصة، خليها تظهر
          if (matchSpecial) return true;
        }

        return false;
      });
    }

    // فلترة حسب التاريخ
    if (filters.dateFrom && filters.dateTo) {
      const fromDateStr = formatDateForAPI(filters.dateFrom);
      const toDateStr = formatDateForAPI(filters.dateTo);
      filteredPours = filteredPours.filter(pour => {
        const pourDate = new Date(pour.castingDate);
        const fromDate = new Date(fromDateStr);
        const toDate = new Date(toDateStr);
        return pourDate >= fromDate && pourDate <= toDate;
      });
    } else if (filters.dateFrom) {
      const fromDateStr = formatDateForAPI(filters.dateFrom);
      filteredPours = filteredPours.filter(pour => {
        const pourDate = new Date(pour.castingDate);
        const fromDate = new Date(fromDateStr);
        return pourDate >= fromDate;
      });
    } else if (filters.dateTo) {
      const toDateStr = formatDateForAPI(filters.dateTo);
      filteredPours = filteredPours.filter(pour => {
        const pourDate = new Date(pour.castingDate);
        const toDate = new Date(toDateStr);
        return pourDate <= toDate;
      });
    }

    return filteredPours.sort((a, b) => new Date(a.castingDate) - new Date(b.castingDate));
  };

  // جلب كل الصبات للعرض
  const getDisplayPours = () => {
    if (searchResults !== null) {
      return searchResults;
    }
    return pours.sort((a, b) => new Date(a.castingDate) - new Date(b.castingDate));
  };

  // حساب الإحصائيات
  const getStationStats = (stationId, stationType) => {
    const stationPours = getPoursByStation(stationId, stationType);
    const totalCubes = stationPours.reduce((sum, pour) => sum + calculateCubes(pour.cubesCount), 0);
    return {
      poursCount: stationPours.length,
      cubesCount: totalCubes
    };
  };

  // تطبيق الفلاتر - إظهار المحطات التي بها صبات فقط بعد الفلترة
  const getFilteredStations = () => {
    return stations;
  };
  const handleFilterChange = (type, value) => {
    setFilters(prev => {
      const newFilters = { ...prev };
      if (type === 'stations' || type === 'specialSections') {
        if (newFilters[type].includes(value)) {
          newFilters[type] = newFilters[type].filter(v => v !== value);
        } else {
          newFilters[type] = [...newFilters[type], value];
        }
      } else {
        newFilters[type] = value;
      }
      return newFilters;
    });
  };

  const handleSearch = () => {
    const hasActiveFilters = filters.stations.length > 0 || 
                            filters.specialSections.length > 0 || 
                            filters.dateFrom || 
                            filters.dateTo;
    
    if (hasActiveFilters) {
      const results = getFilteredPours();
      setSearchResults(results);
      toast.success(`تم العثور على ${results.length} صبة`);
    } else {
      toast.error('الرجاء اختيار فلتر واحد على الأقل');
    }
  };

  const handleClearFilters = () => {
    setFilters({
      stations: [],
      specialSections: [],
      dateFrom: null,
      dateTo: null
    });
    setSearchResults(null);
    toast.success('تم مسح الفلاتر');
  };

  const handleCardClick = (stationId, stationType) => {
    setSelectedCard({ id: stationId, type: stationType });
  };

  const handleBackToCards = () => {
    setSelectedCard(null);
  };

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>☰</button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <button 
              onClick={() => navigate('/cubes')}
              style={{
                background: '#64748b',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600'
              }}
            >
              ← رجوع
            </button>
            <h1>📋 سجل المكعبات الشامل</h1>
          </div>
        </div>

        <div className="dashboard-main">
          <div style={{ padding: '20px', maxWidth: '100%' }}>
            {/* Filters Section */}
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '20px',
              marginBottom: '20px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: showFilters ? '20px' : '0'
              }}>
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700' }}>🔍 فلاتر البحث</h3>
                <button
                  onClick={() => setShowFilters(!showFilters)}
                  style={{
                    background: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600'
                  }}
                >
                  {showFilters ? '▲ إخفاء' : '▼ إظهار'}
                </button>
              </div>

              {showFilters && (
                <div style={{ marginTop: '20px' }}>
                  {/* Stations Filter */}
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#475569'
                    }}>
                      المحطات:
                    </label>
                    <div style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '10px'
                    }}>
                      {stations.filter(s => s.type === 'station').map(station => (
                        <label
                          key={station.id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            padding: '8px 12px',
                            background: filters.stations.includes(station.id) ? '#dbeafe' : '#f1f5f9',
                            border: filters.stations.includes(station.id) ? '2px solid #3b82f6' : '2px solid transparent',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '13px',
                            fontWeight: '500'
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={filters.stations.includes(station.id)}
                            onChange={() => handleFilterChange('stations', station.id)}
                            style={{ cursor: 'pointer' }}
                          />
                          {station.name}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Special Sections Filter */}
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#475569'
                    }}>
                      الأقسام الخاصة:
                    </label>
                    <div style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '10px'
                    }}>
                      {stations.filter(s => s.type === 'special').map(section => (
                        <label
                          key={section.id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            padding: '8px 12px',
                            background: filters.specialSections.includes(section.id) ? '#fef3c7' : '#f1f5f9',
                            border: filters.specialSections.includes(section.id) ? '2px solid #f59e0b' : '2px solid transparent',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '13px',
                            fontWeight: '500'
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={filters.specialSections.includes(section.id)}
                            onChange={() => handleFilterChange('specialSections', section.id)}
                            style={{ cursor: 'pointer' }}
                          />
                          {section.name}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Date Range Filter - UPDATED WITH ENGLISHDATEPICKER */}
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#475569'
                    }}>
                      نطاق التاريخ:
                    </label>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                      <EnglishDatePicker
                        selected={filters.dateFrom}
                        onChange={(date) => handleFilterChange('dateFrom', date)}
                        placeholderText="من تاريخ"
                        maxDate={filters.dateTo || undefined}
                      />
                      <EnglishDatePicker
                        selected={filters.dateTo}
                        onChange={(date) => handleFilterChange('dateTo', date)}
                        placeholderText="إلى تاريخ"
                        minDate={filters.dateFrom || undefined}
                      />
                    </div>
                  </div>

                  {/* Actions */}
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      onClick={handleSearch}
                      style={{
                        padding: '10px 20px',
                        background: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}
                    >
                      🔍 بحث
                    </button>
                    <button
                      onClick={handleClearFilters}
                      style={{
                        padding: '10px 20px',
                        background: '#f1f5f9',
                        color: '#475569',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}
                    >
                      🗑️ مسح الفلاتر
                    </button>
                  </div>
                </div>
              )}
            </div>
			{/* Main Pours Table - Always Visible */}
            {!selectedCard && (
              <>
                {/* All Pours Table */}
                <div style={{
                  background: 'white',
                  borderRadius: '12px',
                  padding: '20px',
                  marginBottom: '30px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px',
                    paddingBottom: '15px',
                    borderBottom: '2px solid #f1f5f9'
                  }}>
                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '800', color: '#1e293b' }}>
                      📋 جميع الصبات ({getDisplayPours().length})
                    </h2>
                  </div>

                  {loading ? (
                    <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
                      <div style={{ fontSize: '64px', marginBottom: '20px', opacity: 0.5 }}>⏳</div>
                      <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>جاري التحميل...</p>
                    </div>
                  ) : getDisplayPours().length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
                      <div style={{ fontSize: '64px', marginBottom: '20px', opacity: 0.5 }}>📋</div>
                      <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>لا توجد صبات حالياً</p>
                    </div>
                  ) : (
                    <div 
                      ref={tableRef}
                      onMouseDown={(e) => handleMouseDown(e, tableRef)}
                      onMouseUp={() => handleMouseUp(tableRef)}
                      onMouseLeave={() => handleMouseUp(tableRef)}
                      onMouseMove={(e) => handleMouseMove(e, tableRef)}
                      style={{ 
                        overflowX: 'auto',
                        cursor: 'grab',
                        userSelect: 'none'
                      }}
                    >
                      <table style={{
                        width: '100%',
                        borderCollapse: 'separate',
                        borderSpacing: 0,
                        fontSize: '13px',
                        minWidth: '1200px'
                      }}>
                        <thead>
                          <tr>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe',
                              position: 'sticky',
                              top: 0
                            }}>#</th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe'
                            }}>
                              <div>Casting</div>
                              <div>Date</div>
                            </th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe'
                            }}>Station</th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                              color: '#92400e',
                              border: '2px solid #fde68a'
                            }}>
                              <div>Serial</div>
                              <div>Number</div>
                            </th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe'
                            }}>Mix</th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe'
                            }}>Location</th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe'
                            }}>No Of Cubes</th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe'
                            }}>
                              <div>Quantity</div>
                              <div>(m³)</div>
                            </th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe'
                            }}>Start</th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe'
                            }}>Finish</th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe',
                              width: '60px'
                            }}>CH</th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe',
                              width: '60px'
                            }}>E.S</th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe'
                            }}>
                              <div>Batch</div>
                              <div>Plant</div>
                            </th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
                              color: '#15803d',
                              border: '2px solid #bbf7d0'
                            }}>Day 7</th>
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%)',
                              color: '#6b21a8',
                              border: '2px solid #c4b5fd'
                            }}>Day 28</th>
                            {currentUser && ['admin', 'engineer', 'supervisor', 'senior'].includes(currentUser.role) && (
                              <th style={{
                                padding: '12px 8px',
                                textAlign: 'center',
                                fontWeight: '700',
                                background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                                color: '#92400e',
                                border: '2px solid #fde68a'
                              }}>Edit</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {getDisplayPours().map((pour, rowIndex) => (
                            <tr key={pour._id} style={{ background: rowIndex % 2 === 0 ? 'white' : '#f9fafb' }}>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569',
                                fontWeight: '600'
                              }}>{rowIndex + 1}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{formatDate(pour.castingDate)}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569',
                                fontWeight: '600'
                              }}>{formatStationName(pour.station)}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                background: '#fef3c7',
                                color: '#92400e',
                                fontWeight: '700',
                                fontSize: '14px'
                              }}>{pour.serialNumber || '-'}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{pour.mix}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{pour.location}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569',
                                fontWeight: '700'
                              }}>
                                {pour.cubesCount?.groups && pour.cubesCount?.cubesPerGroup
                                  ? `${pour.cubesCount.groups}G × ${pour.cubesCount.cubesPerGroup} = ${calculateCubes(pour.cubesCount)}C`
                                  : '-'}
                              </td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{pour.quantity}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{pour.startTime}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{pour.finishTime}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{pour.chemistry || '-'}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{pour.esCubes || '-'}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{pour.batchPlant || '-'}</td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                background: '#dcfce7',
                                color: '#15803d',
                                fontWeight: '700'
                              }}>
                                {(() => {
                                  const day7 = calculateDay7Cubes(pour.cubesCount);
                                  const date = calculateBreakingDate(pour.castingDate, 7);
                                  return day7 
                                    ? (
                                      <div>
                                        <div>{`${day7.groups}G × ${day7.cubesPerGroup} = ${day7.total}`}</div>
                                        <div style={{fontSize: '11px', color: '#059669', marginTop: '2px'}}>{date}</div>
                                      </div>
                                    )
                                    : '-';
                                })()}
                              </td>
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                background: '#e0e7ff',
                                color: '#4338ca',
                                fontWeight: '700'
                              }}>
                                {(() => {
                                  const day28 = calculateDay28Cubes(pour.cubesCount);
                                  const date = calculateBreakingDate(pour.castingDate, 28);
                                  return day28 
                                    ? (
                                      <div>
                                        <div>{`${day28.groups}G × ${day28.cubesPerGroup} = ${day28.total}`}</div>
                                        <div style={{fontSize: '11px', color: '#4f46e5', marginTop: '2px'}}>{date}</div>
                                      </div>
                                    )
                                    : '-';
                                })()}
                              </td>
                              {currentUser && ['admin', 'engineer', 'supervisor', 'senior'].includes(currentUser.role) && (
                                <td style={{
                                  padding: '10px 8px',
                                  textAlign: 'center',
                                  border: '1px solid #e2e8f0'
                                }}>
                                  <button
                                    onClick={() => handleEditPour(pour)}
                                    style={{
                                      padding: '6px 12px',
                                      background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '6px',
                                      fontSize: '13px',
                                      fontWeight: '600',
                                      cursor: 'pointer',
                                      transition: 'all 0.2s'
                                    }}
                                  >
                                    ✏️ Edit
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {/* Cards Grid Below */}
                {!loading && (
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '15px'
                  }}>
                    {getFilteredStations().map(station => (
                      <div
                        key={station.id}
                        onClick={() => handleCardClick(station.id, station.type)}
                        style={{
                          background: 'white',
                          borderRadius: '12px',
                          padding: '20px',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          cursor: 'pointer',
                          transition: 'all 0.3s',
                          border: '2px solid transparent'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-4px)';
                          e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.15)';
                          e.currentTarget.style.borderColor = '#3b82f6';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                          e.currentTarget.style.borderColor = 'transparent';
                        }}
                      >
                        <div style={{ textAlign: 'center' }}>
                          <div style={{ fontSize: '32px', marginBottom: '10px' }}>{station.icon}</div>
                          <div style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', marginBottom: '5px' }}>
                            {station.displayNumber}
                          </div>
                          {station.displayName && (
                            <div style={{ fontSize: '14px', color: '#64748b', fontWeight: '600' }}>
                              {station.displayName}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}

            {/* Single Station View */}
            {selectedCard && (
              <div style={{
                background: 'white',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '20px',
                  paddingBottom: '15px',
                  borderBottom: '2px solid #f1f5f9'
                }}>
                  <button
                    onClick={handleBackToCards}
                    style={{
                      background: '#64748b',
                      color: 'white',
                      border: 'none',
                      padding: '10px 20px',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    ← رجوع للبطاقات
                  </button>
                  <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '800', color: '#1e293b' }}>
                    <span>{stations.find(s => s.id === selectedCard.id)?.icon}</span>
                    {' '}
                    {stations.find(s => s.id === selectedCard.id)?.name}
                  </h2>
                </div>

                {loading ? (
                  <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
                    <div style={{ fontSize: '64px', marginBottom: '20px', opacity: 0.5 }}>⏳</div>
                    <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>جاري التحميل...</p>
                  </div>
                ) : getPoursByStation(selectedCard.id, selectedCard.type).length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
                    <div style={{ fontSize: '64px', marginBottom: '20px', opacity: 0.5 }}>📋</div>
                    <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>لا توجد بيانات حالياً</p>
                  </div>
                ) : (
                  <div 
                    ref={tableRef2}
                    onMouseDown={(e) => handleMouseDown(e, tableRef2)}
                    onMouseUp={() => handleMouseUp(tableRef2)}
                    onMouseLeave={() => handleMouseUp(tableRef2)}
                    onMouseMove={(e) => handleMouseMove(e, tableRef2)}
                    style={{ 
                      overflowX: 'auto',
                      cursor: 'grab',
                      userSelect: 'none'
                    }}
                  >
                    <table style={{
                      width: '100%',
                      borderCollapse: 'separate',
                      borderSpacing: 0,
                      fontSize: '13px',
                      minWidth: '1200px'
                    }}>
                      <thead>
                        <tr>
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                            color: '#1e40af',
                            border: '2px solid #bfdbfe'
                          }}>#</th>
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                            color: '#1e40af',
                            border: '2px solid #bfdbfe'
                          }}>
                            <div>Casting</div>
                            <div>Date</div>
                          </th>
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                            color: '#1e40af',
                            border: '2px solid #bfdbfe'
                          }}>Station</th>
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                            color: '#92400e',
                            border: '2px solid #fde68a'
                          }}>
                            <div>Serial</div>
                            <div>Number</div>
                          </th>
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                            color: '#1e40af',
                            border: '2px solid #bfdbfe'
                          }}>Mix</th>
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                            color: '#1e40af',
                            border: '2px solid #bfdbfe'
                          }}>Location</th>
                          {selectedCard.id !== 'Chemical' && selectedCard.id !== 'ES' && (
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe'
                            }}>No Of Cubes</th>
                          )}
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                            color: '#1e40af',
                            border: '2px solid #bfdbfe'
                          }}>
                            <div>Quantity</div>
                            <div>(m³)</div>
                          </th>
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                            color: '#1e40af',
                            border: '2px solid #bfdbfe'
                          }}>Start</th>
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                            color: '#1e40af',
                            border: '2px solid #bfdbfe'
                          }}>Finish</th>
                          {selectedCard.id !== 'ES' && (
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe',
                              width: '60px'
                            }}>CH</th>
                          )}
                          {selectedCard.id !== 'Chemical' && (
                            <th style={{
                              padding: '12px 8px',
                              textAlign: 'center',
                              fontWeight: '700',
                              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                              color: '#1e40af',
                              border: '2px solid #bfdbfe',
                              width: '60px'
                            }}>E.S</th>
                          )}
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                            color: '#1e40af',
                            border: '2px solid #bfdbfe'
                          }}>
                            <div>Batch</div>
                            <div>Plant</div>
                          </th>
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
                            color: '#15803d',
                            border: '2px solid #bbf7d0'
                          }}>Day 7</th>
                          <th style={{
                            padding: '12px 8px',
                            textAlign: 'center',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%)',
                            color: '#6b21a8',
                            border: '2px solid #c4b5fd'
                          }}>Day 28</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getPoursByStation(selectedCard.id, selectedCard.type).map((pour, rowIndex) => (
                          <tr key={pour._id} style={{ background: rowIndex % 2 === 0 ? 'white' : '#f9fafb' }}>
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              color: '#475569',
                              fontWeight: '600'
                            }}>{rowIndex + 1}</td>
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              color: '#475569'
                            }}>{formatDate(pour.castingDate)}</td>
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              color: '#475569',
                              fontWeight: '600'
                            }}>{formatStationName(pour.station)}</td>
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              background: '#fef3c7',
                              color: '#92400e',
                              fontWeight: '700',
                              fontSize: '14px'
                            }}>{pour.serialNumber || '-'}</td>
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              color: '#475569'
                            }}>{pour.mix}</td>
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              color: '#475569'
                            }}>{pour.location}</td>
                            {selectedCard.id !== 'Chemical' && selectedCard.id !== 'ES' && (
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569',
                                fontWeight: '700'
                              }}>
                                {pour.cubesCount?.groups && pour.cubesCount?.cubesPerGroup
                                  ? `${pour.cubesCount.groups}G × ${pour.cubesCount.cubesPerGroup} = ${calculateCubes(pour.cubesCount)}C`
                                  : '-'}
                              </td>
                            )}
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              color: '#475569'
                            }}>{pour.quantity}</td>
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              color: '#475569',
                              fontWeight: '600'
                            }}>{formatTime24(pour.startTime)}</td>
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              color: '#475569',
                              fontWeight: '600'
                            }}>{formatTime24(pour.finishTime)}</td>
                            {selectedCard.id !== 'ES' && (
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{pour.chemistry || '-'}</td>
                            )}
                            {selectedCard.id !== 'Chemical' && (
                              <td style={{
                                padding: '10px 8px',
                                textAlign: 'center',
                                border: '1px solid #e2e8f0',
                                color: '#475569'
                              }}>{pour.esCubes || '-'}</td>
                            )}
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              color: '#475569'
                            }}>{pour.batchPlant || '-'}</td>
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              background: '#dcfce7',
                              color: '#15803d',
                              fontWeight: '700'
                            }}>
                              {(() => {
                                const day7 = calculateDay7Cubes(pour.cubesCount);
                                const date = calculateBreakingDate(pour.castingDate, 7);
                                return day7 
                                  ? (
                                    <div>
                                      <div>{`${day7.groups}G × ${day7.cubesPerGroup} = ${day7.total}`}</div>
                                      <div style={{fontSize: '11px', color: '#059669', marginTop: '2px'}}>{date}</div>
                                    </div>
                                  )
                                  : '-';
                              })()}
                            </td>
                            <td style={{
                              padding: '10px 8px',
                              textAlign: 'center',
                              border: '1px solid #e2e8f0',
                              background: '#e0e7ff',
                              color: '#4338ca',
                              fontWeight: '700'
                            }}>
                              {(() => {
                                const day28 = calculateDay28Cubes(pour.cubesCount);
                                const date = calculateBreakingDate(pour.castingDate, 28);
                                return day28 
                                  ? (
                                    <div>
                                      <div>{`${day28.groups}G × ${day28.cubesPerGroup} = ${day28.total}`}</div>
                                      <div style={{fontSize: '11px', color: '#4f46e5', marginTop: '2px'}}>{date}</div>
                                    </div>
                                  )
                                  : '-';
                              })()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {showEditModal && editPour && (
        <EditPourModal
          pour={editPour}
          onClose={handleCloseEditModal}
          onUpdate={handleUpdateSuccess}
        />
      )}
    </div>
  );
};

export default CubesLog;